function StatsCard({ title, value, icon, change, changeText, colorHint = "var(--accent-orange)", subtitle }) {
  const isPositive = change && change.startsWith('+');
  const isNegative = change && change.startsWith('-');
  
  return (
    <div className="stats-card">
      {/* Background glow */}
      <div className="stats-card-glow" style={{ background: `radial-gradient(circle, ${colorHint} 0%, transparent 70%)` }} />
      
      <div className="stats-card-content">
        <div className="stats-card-info">
          <p className="stats-card-label">{title}</p>
          <h3 className="stats-card-value">{value}</h3>
          {subtitle && <p className="stats-card-subtitle">{subtitle}</p>}
        </div>
        <div className="stats-card-icon" style={{ 
          backgroundColor: `color-mix(in srgb, ${colorHint} 15%, transparent)`, 
          color: colorHint 
        }}>
          {icon}
        </div>
      </div>
      
      {change && (
        <div className="stats-card-change">
          <span className={`change-badge ${isPositive ? 'positive' : isNegative ? 'negative' : ''}`}>
            {change}
          </span>
          <span className="change-text">{changeText}</span>
        </div>
      )}
    </div>
  );
}

export default StatsCard;
